// Initialize CKEditors
let element_needs_wysiwyg = window.$('.wysiwyg-please');
if (element_needs_wysiwyg) {
  setTimeout(function () {
    element_needs_wysiwyg.each(function (index, element) {
      CKEDITOR.replace(window.$(element).attr('name'), {
        uiColor: '#dddddd'
      });
    });
  }, 150);
}